import { Button } from '@storeblocks/button';
import { type FC, useState } from 'react';

import { useTexts } from '@/hooks/useTexts';
import { TrackingElement, useGetTrackId } from '@/tracking';

import { AddFundsModal } from '../AddFundsModal';

export const AddFundsButton: FC = () => {
  const texts = useTexts();
  const getTrackId = useGetTrackId();

  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        iconLeft="add"
        variant="tertiary"
        onClick={() => setIsModalOpen(true)}
        data-test="open-add-funds-modal-button"
        data-trackid={getTrackId(
          'open-add-funds-modal',
          TrackingElement.Button,
        )}
      >
        {texts.orders.form.addFundModal.button.open}
      </Button>

      <AddFundsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};
